import { render, staticRenderFns } from "./BioModelPanel.vue?vue&type=template&id=449d16bc&"
import script from "./BioModelPanel.vue?vue&type=script&lang=js&"
export * from "./BioModelPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BioModelPanel.vue"
export default component.exports